import { AST } from '../ast';
import { mapExprFR } from './map-expr-fr';

export const attributesInExpr = (
  ast: AST.ExprFR
): { source: 'left' | 'right' | 'from'; name: string }[] => {
  const attrs: { source: 'left' | 'right' | 'from'; name: string }[] = [];

  mapExprFR(ast, (x) => {
    if (x.t === 'attr') {
      attrs.push({ source: x.source, name: x.name });
    }
    return x;
  });

  return attrs;
};
